/* eslint-disable @typescript-eslint/no-unused-vars */
import { createReducer, on } from '@ngrx/store';
import { AppLockApiActions } from './category-app-lock.actions';
import { adapter, initialState, selectId } from './category-app-lock.state';

export const appLockReducer = createReducer(
  initialState,
  on(AppLockApiActions.appLockLoaded, (state, { appLocks }) => {
    return adapter.upsertMany(appLocks, state);
  }),
  on(AppLockApiActions.appLockSet, (state, { appLocks }) => {
    const appLocksToSet = appLocks.modelNames.map((modelName) => {
      // removes modelNames, adds 1 modelName for each to make AppLocks
      const { ['modelNames']: _, ...noModelNames } = appLocks;
      return { ...noModelNames, modelName: modelName };
    });
    return adapter.upsertMany(appLocksToSet, state);
  }),
  on(AppLockApiActions.appLockRemoved, (state, { appLocks }) => {
    const keysToRemove = appLocks.modelNames.map((modelName) =>
      selectId(appLocks.categoryType, appLocks.categoryId, appLocks.appLockState, modelName)
    );
    return adapter.removeMany(keysToRemove, state);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAppLockIds = selectIds;

export const selectAppLockEntities = selectEntities;

export const selectAllAppLocks = selectAll;
